// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__AAouY","title":"ClientInsurance_title__3dtTb","itemText":"ClientInsurance_itemText__2REyq"};